import React, { PropsWithChildren, useEffect, useRef, useState } from "react";
import { Box, type BoxProps, Typography } from "@mui/material";
import { motion, AnimatePresence, type HTMLMotionProps } from "framer-motion";
import { colors } from "../../styles/theme";
import { AnimatedLogo, AnimatedLogoProps } from "../AnimatedLogo/AnimatedLogo";
import { convertToBreakpoints, getFluidsByKeys, getFluidsByKeysFunc } from "../../utils/fuilds";
import { StyledBorderFrame } from "../App/App.styled";
import { BREAKPOINT_MOBILE } from "../../constants";
import { Overlay } from "../Overlay/Overlay";

const MotionBox = motion.create(Box) as React.ComponentType<BoxProps & HTMLMotionProps<"div">> | any;

export type LoaderProps = PropsWithChildren<
  {
    open: boolean;
    logoProps?: AnimatedLogoProps;
    hideLoadingText?: boolean;
  } & BoxProps
>;

export const Loader: React.FC<LoaderProps> = (props) => {
  const {
    open,
    children,
    sx,
    logoProps,
    hideLoadingText= false,
    ...rest
  } = props;

  return (
    <Overlay open={open}>
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        ...sx,
        // height: "100%",
        // height: "inherit",
        // padding: "10vh 0"
      }}>
        <AnimatedLogo
          className={'animated-logo'}
          // imageUrl={ImgBgDots}
          animationTime={1000}
          {...logoProps}
          sx={(theme => ({
            width: '100%',
            height: '100%',
            [theme.breakpoints.down(BREAKPOINT_MOBILE)]: {
              maxHeight: "139px",
            },
            [theme.breakpoints.between(BREAKPOINT_MOBILE, 'xl')]: {
              maxHeight: "180px",
            },
            [theme.breakpoints.up('xl')]: {
              maxHeight: "481px",
            },
          }))}
        />

        {
          !hideLoadingText && (
            <Typography variant={"v7"} sx={(theme) => ({
              position: "relative",
              color: colors.text.v4,
              "&::after": {
                content: "''",
                animation: "dots 2.5s ease-in-out infinite",
                animationDirection: "alternate",
                position: "absolute",
                left: "100%",
                bottom: 0,
                "@keyframes dots": {
                  "0%": {
                    content: "'.'",
                    color: 'transparent',
                  },
                  "33%": {
                    content: "'.'",
                  },
                  "66%": {
                    content: "'..'",
                  },
                  "100%": {
                    content: "'...'",
                  }
                },
              },
              // marginTop: '150px',
              // marginTop: '5.3vh',
              ...convertToBreakpoints(theme, {
                xs: { marginTop: "20px" },
                md: { marginTop: "5.3vh" }
              })
            })}>loading</Typography>
          )
        }
        {children}
      </Box>
    </Overlay>
  );
};
